import { Col, notification, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Localizacao from '../../../components/Localizacao';
import { useAuth } from '../../../security/authContext';
import { checkPermission } from '../../../security/Can';
import apiNetCore from '../../../services/apiNetCore';
import apiShipper from '../../../services/apiShipper';
import { getColumns } from './columns';
import ModalListDocuments from './Modal/modalListDocuments';
import {
  Button,
  Content,
  Divider,
  Form,
  Item,
  LinhaStatusDireita,
  LinhaStatusEsquerda,
  Status,
  StatusItem,
  Table,
  Texto,
} from './styles';

const { Text } = Typography;

export default function FilaEmbarque({ dadosLote }) {
  const history = useHistory();

  const { user } = useAuth();

  const [form] = Form.useForm();
  const [lotes, setLotes] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [modalLocalizacaoVisible, setModalLocalizacaoVisible] = useState(false);
  const [filtersPage, setFiltersPage] = useState({});
  const [dataLocalizacao, setDataLocalizacao] = useState({});
  const [totalizadores, setTotalizadores] = useState({});
  const [showModalListDocuments, setShowModalListDocuments] = useState(false);
  const [arrayDocumentsDownload, setArrayDocumentsDownload] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    position: ['bottomCenter'],
  });

  const definirOrdenacao = (params, sorter) => {
    const order = sorter.order === 'ascend' ? '0' : '1';
    const { columnKey } = sorter;
    let column = columnKey;

    switch (columnKey) {
      case 'Nome':
        column = 'Conjunto.MotoristaBase.Nome';
        break;
      case 'PlacaCavalo':
        column = 'Conjunto.PlacaCavalo';
        break;
      default:
        break;
    }

    params.Order = {
      Campo: column,
      Operador: order,
    };

    return params;
  };

  const definirFiltrosDinamicos = (params, filters) => {
    const filter = [];
    const possibleKeys = [
      'status',
      'nome',
      'placaCavalo',
      'entradaFila',
      'validade',
    ];

    Object.keys(filters).forEach(key => {
      if (filters[key] && possibleKeys.includes(key)) {
        const value = filters[key];
        switch (key) {
          case 'status':
            filter.push({
              Campo: 'Status',
              Operador: 16,
              Valor: value[0],
              CampoTipo: 2,
            });
            break;
          case 'nome':
            filter.push({
              Campo: 'Conjunto.MotoristaBase.Nome',
              Operador: 16,
              Valor: value[0],
              CampoTipo: 1,
            });
            break;
          case 'placaCavalo':
            filter.push({
              Campo: 'Conjunto.PlacaCavalo',
              Operador: 16,
              Valor: value[0],
              CampoTipo: 1,
            });
            break;
          case 'entradaFila':
            filter.push(
              {
                Campo: 'EntradaFila',
                Operador: 64,
                Valor: value[0],
                CampoTipo: 0,
              },
              {
                Campo: 'EntradaFila',
                Operador: 256,
                Valor: value[1],
                CampoTipo: 0,
              }
            );
            break;
          case 'validade':
            filter.push(
              {
                Campo: 'Validade',
                Operador: 64,
                Valor: value[0],
                CampoTipo: 0,
              },
              {
                Campo: 'Validade',
                Operador: 256,
                Valor: value[1],
                CampoTipo: 0,
              }
            );
            break;
          default:
            break;
        }
      }
    });

    return filter;
  };

  const clearArrayDocumentosDownload = () => {
    setArrayDocumentsDownload([]);
  };

  const handleShowModalListDocuments = async record => {
    setLoadingTable(true);

    try {
      const { data } = await apiShipper.get(
        `/documentos/${record.idLoteConjunto}`
      );
      setShowModalListDocuments(true);
      if (data) setArrayDocumentsDownload(data);
    } catch (err) {
      notification.warning({
        message:
          'Ops, não foi possível localizar os dados de documentos para impressão',
        description: 'Dados de documentos não disponível',
      });
    } finally {
      setLoadingTable(false);
    }
  };

  const handleCloseModalListDocuments = () => {
    setShowModalListDocuments(false);
    clearArrayDocumentosDownload();
  };

  const onClickLocalizacao = async record => {
    try {
      if (record?.idLoteConjunto > 0) {
        const response = await apiNetCore.get(
          '/MotoristaBaseAts/GetLocalizacaoMotorista',
          {
            params: {
              idLoteConjunto: record.idLoteConjunto,
            },
          }
        );

        const obj = {
          cidade: response?.data?.cidade,
          estado: response?.data?.estado,
          dataUltimoCheckIn: response?.data?.dataUltimoCheckIn,
          placa: record?.placaCavalo,
          status: record?.status_lote_conjunto,
        };

        setModalLocalizacaoVisible(true);
        setDataLocalizacao(obj);
      }
    } catch (err) {
      notification.warning({
        message: 'Ops, não foi possível recuperar a localização',
        description: 'Localização não disponível',
      });
    }
  };

  const onClickMotoristaEmViagem = () => {
    if (!dadosLote.idLote) return;

    history.push(`/mapa-gerenciamento/${dadosLote.idLote}`);
  };

  const handlerOnChangePagination = useCallback(async () => {
    try {
      setLoadingTable(true);

      const { current, pageSize } = pagination;

      let body = {
        idLotes: [dadosLote.idLote],
        Page: current,
        Take: pageSize,
        Filters: [],
      };
      if (filtersPage?.sorter?.order) {
        body = {
          ...definirOrdenacao(body, filtersPage.sorter),
        };
      }
      if (filtersPage?.filters && Object.keys(filtersPage.filters).length) {
        body.Filters = definirFiltrosDinamicos(body, filtersPage.filters);
      }

      const loadTotalizadores = apiNetCore
        .post('LoteConjuntoAts/ObterTotalizadorFilaEmbarque', {
          idLotes: [dadosLote.idLote],
        })
        .then(({ data }) => setTotalizadores(data));

      const loadMotoristas = apiNetCore
        .post('/LoteConjuntoAts/ConsultarGridFila', body)
        .then(({ data }) => {
          setLotes(data.items);
          setPagination({
            ...pagination,
            current,
            pageSize,
            total: data.totalItems,
          });
        });

      await Promise.all([loadTotalizadores, loadMotoristas]);
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os dados do lote',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingTable(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtersPage.filters,
    filtersPage.sorter,
    form,
    user.clientes_pagadores,
    user.id,
  ]);

  useEffect(() => {
    handlerOnChangePagination();
  }, [handlerOnChangePagination]);

  const onChangeTable = (paginationParam, filters, sorter) => {
    setPagination({
      ...paginationParam,
    });
    setFiltersPage({
      ...filtersPage,
      filters,
      sorter,
    });
  };

  const columnsTable = getColumns(
    filtersPage,
    onClickLocalizacao,
    handleShowModalListDocuments,
    handleCloseModalListDocuments
  );

  return (
    <>
      <Localizacao
        dataLocalizacao={dataLocalizacao}
        modalLocalizacaoVisible={modalLocalizacaoVisible}
        setModalLocalizacaoVisible={setModalLocalizacaoVisible}
      />
      <ModalListDocuments
        arrayDocumentsDownload={arrayDocumentsDownload}
        showModalListDocuments={showModalListDocuments}
        handleShowModalListDocuments={handleShowModalListDocuments}
        handleCloseModalListDocuments={handleCloseModalListDocuments}
      />
      <Content>
        <Col span={24}>
          <Row>
            <Col>
              <Text>Status geral de embarque:</Text>
            </Col>
          </Row>
          <Row>
            <Col span={19}>
              <LinhaStatusEsquerda>
                <Row>
                  <StatusItem>
                    <Status>
                      <Texto>Em Trânsito</Texto>
                      <Item color="#24A95D">
                        {totalizadores.totalEmTransito}
                      </Item>
                    </Status>
                  </StatusItem>
                  <Divider />
                  <StatusItem>
                    <Status>
                      <Texto>Na Fila</Texto>
                      <Item color="#56CCF2">{totalizadores.totalNaFila}</Item>
                    </Status>
                  </StatusItem>
                </Row>
                <Row>
                  <Divider />
                  <StatusItem>
                    <Status>
                      <Texto>Embarcado</Texto>
                      <Item color="#6E51E0">
                        {totalizadores.totalEmbarcados}
                      </Item>
                    </Status>
                  </StatusItem>
                  <Divider />
                  <StatusItem>
                    <Status>
                      <Texto>Entregue</Texto>
                      <Item color="#1271EE">{totalizadores.totalEntregue}</Item>
                    </Status>
                  </StatusItem>
                </Row>
              </LinhaStatusEsquerda>
            </Col>
            <Col span={5}>
              <LinhaStatusDireita>
                <Row>
                  <StatusItem>
                    <Status>
                      <Texto>Desistiu</Texto>
                      <Item color="#BF6211">{totalizadores.totalDesistiu}</Item>
                    </Status>
                  </StatusItem>
                  <StatusItem>
                    <Status>
                      <Texto>Removido</Texto>
                      <Item color="#D42929">{totalizadores.totalRemovido}</Item>
                    </Status>
                  </StatusItem>
                </Row>
              </LinhaStatusDireita>
            </Col>
          </Row>
          <Row justify="space-between" align="middle">
            <Col className="mb-15">
              <Text>Lista de motoristas:</Text>
            </Col>
            {checkPermission(user.permissions, 'mapa-gerenciamento:show') && (
              <Col>
                <Button
                  className="mr-15"
                  onClick={onClickMotoristaEmViagem}
                  color="#4190F7"
                >
                  Visualizar motoristas no mapa
                </Button>
              </Col>
            )}
          </Row>
          <Row>
            <Col span={24}>
              <Table
                loading={loadingTable}
                dataSource={
                  lotes.length &&
                  lotes.map(lote => ({
                    ...lote,
                    key: lote.idLoteConjunto,
                  }))
                }
                onChange={onChangeTable}
                columns={columnsTable}
                pagination={{
                  ...pagination,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Content>
    </>
  );
}

FilaEmbarque.propTypes = {
  dadosLote: PropTypes.objectOf(PropTypes.any).isRequired,
};
